import React from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
    return (
        <nav
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "16px 32px",
                background: "#fffbe7",
                borderBottom: "1px solid #ffe18d",
                position: "sticky",
                top: 0,
                zIndex: 999
            }}
            aria-label="Main Navigation"
        >
            <div
                style={{
                    fontWeight: "bold",
                    fontSize: "1.5em",
                    color: "#e8a700",
                    display: "flex",
                    alignItems: "center"
                }}
            >
                <img
                    src="/logo192.png"
                    alt="Jangcoin Logo"
                    style={{ height: 32, marginRight: 10 }}
                />
                Jangcoin
            </div>
            <div>
                <Link
                    to="/"
                    style={{
                        marginRight: 22,
                        color: "#c39000",
                        fontWeight: 600,
                        textDecoration: "none"
                    }}
                    aria-label="Home"
                >
                    Home
                </Link>
                <Link
                    to="/faq"
                    style={{
                        marginRight: 22,
                        color: "#c39000",
                        fontWeight: 600,
                        textDecoration: "none"
                    }}
                    aria-label="FAQ"
                >
                    FAQ
                </Link>
                <Link
                    to="/dashboard"
                    style={{
                        color: "#c39000",
                        fontWeight: 600,
                        textDecoration: "none"
                    }}
                    aria-label="Dashboard"
                >
                    Dashboard
                </Link>
            </div>
        </nav>
    );
}
